var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGenetic = function SvgGenetic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "m17.5 28 2.625 2.625M24.5 14l-2.625-2.625M26.25 3.5c-3.146 3.497-4.407 6.991-4.912 10.488M28.875 18.375l1.75 1.75M29.75 10.5l-5.06-5.06M3.5 26.25c11.667-10.5 23.333 0 35-10.5M35 15.75l1.56 1.56M5.44 24.69 7 26.25M11.375 21.875l1.75 1.75M12.25 31.5l5.06 5.06M15.75 38.5c3.146-3.496 4.407-6.991 4.912-10.488"
  })));
};
export default SvgGenetic;